import { FC } from 'react';
import { getColorValue } from '@shinetools/sunshine';
import { ComposedChart, Line } from 'recharts';

import { activeDot } from 'features/Dashboard/common';

import CartesianGridNoDashHorizontal from '../../../CartesianGridNoDashHorizontal';
import Graph from '../../../Graph';
import { FULL_WIDTH_LINE_GRAPH_HEIGHT } from '../../constants';

const placeholderData = [
  {
    date: '2023-10-01',
    defaultValue: 0,
  },
  {
    date: '2023-10-05',
    defaultValue: 0,
  },
  {
    date: '2023-10-10',
    defaultValue: 1,
  },
  {
    date: '2023-10-15',
    defaultValue: 2,
  },
  {
    date: '2023-10-20',
    defaultValue: 4,
  },
  {
    date: '2023-10-25',
    defaultValue: 5,
  },
  {
    date: '2023-10-30',
    defaultValue: 7,
  },
];

export const LoadingFullWidthLineGraph: FC = () => (
  <Graph height={FULL_WIDTH_LINE_GRAPH_HEIGHT}>
    <Graph.Body>
      <ComposedChart data={placeholderData}>
        <CartesianGridNoDashHorizontal />

        <Line
          activeDot={activeDot('grey.200')}
          dataKey="defaultValue"
          dot={false}
          stroke={getColorValue('grey.200')}
          strokeLinecap="round"
          strokeWidth={2}
          type="monotone"
        />
      </ComposedChart>
    </Graph.Body>
  </Graph>
);

export default LoadingFullWidthLineGraph;
